import React, { useState } from "react";
import logo from "../assets/newLogorb.png";
import background from "../assets/VieshBg.jpg";

export default function ComingSoon() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // For actual use, replace the alert logic with real submission function
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim().length > 3 && email.includes("@")) {
      setSubmitted(true);
      setEmail("");
      setTimeout(() => setSubmitted(false), 2500);
    }
  };

  return (
    <div
      className="min-h-screen font-basefont flex items-center justify-center px-4 sm:px-8 relative bg-center bg-cover"
      style={{
        backgroundImage: `url(${background})`
      }}
    >

      {/* Overlay for background opacity */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: "#fff",
          opacity: 0.5,
          zIndex: 0
        }}
      />
      <div className="relative z-10 w-full flex flex-col items-center mt-10">
        <div className="bg-white/90 shadow-xl rounded-3xl w-full max-w-sm sm:max-w-4xl mx-4 text-center
         py-8 px-4 sm:px-10 border border-[#bf9247] flex flex-col items-center ">
          <img
            src={logo}
            alt="Boutique Logo"
            className="w-48 h-full object-contain mx-auto mb-2 mt-12"
          />

          <h1 className="text-3xl  sm:text-4xl font-medium text-[#ae001d] mb-4 leading-snug">
            Immerse yourself in the Grandeur of Kanjivaram Silk Sarees
          </h1>

          <p className="text-[#bf9247] text-lg font-medium mb-2">
            Our Exclusive Saree Boutique is getting dressed up!
          </p>

          <p className="mt-3 inline-block bg-[#faf6eb]/10 text-[#000] font-semibold text-md italic px-4 py-2 rounded-md shadow-sm">
            Launching soon with timeless Tradition &amp; Trend.
          </p>

          {/* Email Signup */}
          <form
            onSubmit={handleSubscribe}
            className="mt-4 flex flex-col sm:flex-row justify-center items-center gap-3 w-full max-w-sm mx-auto"
            autoComplete="off"
          >
            <input
              type="email"
              name="email"
              className="w-full border border-[#c5a558] rounded-lg px-4 py-2 text-base text-[#000] focus:outline-none focus:ring-2 focus:ring-[#c5a558] bg-white/90"
              placeholder="Enter your email for updates"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              maxLength={80}
              aria-label="Email address"
              autoFocus={false}
            />
            <button
              type="submit"
              className="bg-[#c5a558] text-white font-semibold px-6 py-2 rounded-lg hover:bg-[#e2cfa3] transition"
              aria-label="Notify"
              disabled={submitted}
            >
              {submitted ? "Subscribed!" : "Notify"}
            </button>
          </form>

          {submitted && (
            <div className="text-green-700 font-medium mt-2 animate-fade-in">
              Thank you! You'll be the first to know.
            </div>
          )}
        </div>
      </div>
      {/* Custom CSS for fade-in animation */}
      <style>{`
        .animate-fade-in {
          animation: fadeIn 1s cubic-bezier(.31,1.02,.38,.98) both;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(16px);}
          to   { opacity: 1; transform: translateY(0);}
        }
      `}</style>
    </div>
  );
}
